import React, { useState } from "react";
import { Link } from "react-router-dom";
import account from "../../images/account-image.png";
import logo from "../../images/logo.png";
import RegistrationDone from "./RegistrationDone";
import { AuthService } from "../../services/Auth.service";
import { DatePicker, message, Select } from "antd";

export default function SignUp({ notify }) {
  const [loading, setLoading] = useState(false);
  const [isFormSuccess, setFormSuccess] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    companyName: "",
    medical_license_id: "",
    email: "",
    password: "",
    isSoloDoctor: false,
    phone_number: "", // For solo doctor
    address: "", // For solo doctor
    provider_name: "", // For hospital
    provider_type: "", // For hospital
    provider_address: "", // For hospital
  });

  const showSuccessMessage = () => {
    messageApi.success({
      content: `User Account Created`,
      duration: 3,
    });
  };

  const showErrorMessage = (error) => {
    messageApi.error({
      content: error.response?.data?.message || "An error occurred",
      duration: 5,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onChange = (_date, dateString) => {
    setFormData((prev) => ({
      ...prev,
      date_of_birth: dateString,
    }));
  };

  const handleGenderSelect = (value) => {
    setFormData((prev) => ({
      ...prev,
      gender: value,
    }));
  };

  const toggleDoctorType = (isSolo) => {
    setFormData((prevData) => ({
      ...prevData,
      isSoloDoctor: isSolo,
      provider_name: isSolo ? "" : prevData.provider_name,
      provider_type: isSolo ? "" : prevData.provider_type,
      provider_address: isSolo ? "" : prevData.provider_address,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (formData.isSoloDoctor) {
        await AuthService.SignUp(formData);
        showSuccessMessage();
        navigate("/login");
        setFormSuccess(true);
      } else {
        await AuthService.ProviderSignup(formData);
        showSuccessMessage();
        navigate("/login");
        setFormSuccess(true);
      }
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleProviderSelect = (value) => {
    setFormData((prev) => ({
      ...prev,
      provider_type: value,
    }));
  };

  return (
    <div>
      {contextHolder}
      <div className="flex justify-between items-center h-screen overflow-hidden font-euclid-circular-a">
        <div className="flex flex-col md:flex-row items-center h-screen">
          <div className="w-full hidden lg:block">
            <img src={account} alt="account" className="h-full w-full" />
          </div>

          <div className="flex flex-col justify-center mt-12">
            <div className="ml-auto mb-10">
              <div className="w-full flex justify-center">
                {isFormSuccess ? (
                  <RegistrationDone />
                ) : (
                  <div className="w-4/5 text-center">
                    <div className="flex justify-center">
                      <img src={logo} alt="" className="mb-2 mt-4 max-w-full" />
                    </div>
                    <h2 className="mb-10 text-center font-bold text-xl">
                      Create an account
                    </h2>
                    <div className="in_btn no-w my-5 h-16 p-2">
                      <button
                        type="button"
                        className={formData.isSoloDoctor ? "active" : ""}
                        onClick={() => toggleDoctorType(true)}
                      >
                        Solo Doctor
                      </button>
                      <button
                        type="button"
                        className={!formData.isSoloDoctor ? "active" : ""}
                        onClick={() => toggleDoctorType(false)}
                      >
                        Hospital
                      </button>
                    </div>
                    <form
                      id="sign_up_form"
                      onSubmit={handleSubmit}
                      className="overflow-y-auto h-[350px]"
                    >
                      {formData.isSoloDoctor ? (
                        <>
                          <input
                            type="text"
                            name="phone_number"
                            value={formData.phone_number}
                            placeholder="Phone Number"
                            className="mb-4 w-full text-black border border-gray-200 p-2"
                            onChange={handleInputChange}
                          />
                          <input
                            type="text"
                            name="address"
                            value={formData.address}
                            placeholder="Address"
                            className="mb-4 w-full text-black border border-gray-200 p-2"
                            onChange={handleInputChange}
                          />
                        </>
                      ) : (
                        <>
                          <input
                            type="text"
                            name="provider_name"
                            value={formData.provider_name}
                            placeholder="Provider Name"
                            className="mb-4 w-full text-black border border-gray-200 p-2"
                            onChange={handleInputChange}
                          />
                          <Select
                            onChange={handleProviderSelect}
                            className="w-full mb-4 h-[42px] rounded-none font-bold"
                            placeholder="Provider Type"
                            options={[
                              {
                                value: "hospital",
                                label: "Hospital",
                              },
                              {
                                value: "lab",
                                label: "Lab",
                              },
                              {
                                value: "HMO",
                                label: "HMO",
                              },
                              {
                                value: "pharmacy",
                                label: "Pharmacy",
                              },
                            ]}
                          />
                          <input
                            type="text"
                            name="provider_address"
                            value={formData.provider_address}
                            placeholder="Provider Address"
                            className="mb-4 w-full text-black border border-gray-200 p-2"
                            onChange={handleInputChange}
                          />
                        </>
                      )}
                      <div className="flex mb-4 w-full">
                        <input
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          placeholder="First name"
                          className="w-1/2 border border-gray-200 p-2"
                          onChange={handleInputChange}
                        />
                        <input
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          placeholder="Last name"
                          className="w-1/2 border border-gray-200 p-2"
                          onChange={handleInputChange}
                        />
                      </div>

                      <input
                        type="text"
                        name="medical_license_id"
                        value={formData.medical_license_id}
                        placeholder="Medical license ID"
                        className="mb-4 w-full text-black border border-gray-200 p-2"
                        onChange={handleInputChange}
                      />
                      <div className="w-full items-center mb-4">
                        <Select
                          onChange={handleGenderSelect}
                          className="w-1/2 h-[42px] rounded-none font-bold"
                          placeholder="Gender"
                          options={[
                            {
                              value: "male",
                              label: "Male",
                            },
                            {
                              value: "female",
                              label: "Female",
                            },
                          ]}
                        />
                        <DatePicker
                          onChange={onChange}
                          placeholder="Date of birth"
                          className="w-1/2 border border-gray-200 p-2 rounded-none font-bold h-[42px]"
                        />
                      </div>
                      <input
                        type="text"
                        name="email"
                        value={formData.email}
                        placeholder="Email address"
                        className="mb-4 w-full text-black border border-gray-200 p-2"
                        onChange={handleInputChange}
                      />
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        placeholder="Password"
                        className="mb-4 w-full border text-black border-gray-200 p-2"
                        onChange={handleInputChange}
                      />
                      <button
                        type="submit"
                        className="bg-sky-500 text-white px-4 py-2 rounded w-full"
                      >
                        {loading ? "loading..." : "Sign up"}
                      </button>
                    </form>
                    <p className="mb-6 text-xs mt-4">
                      Already have an account?{" "}
                      <Link
                        to="/login"
                        className="text-blue-600 hover:text-gray-400 transition duration-200 ease-in-out ml-1"
                      >
                        Login
                      </Link>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
